module.exports = __webpack_public_path__ + "img/card_ip_stipulation49.4fb4e7fa.svg";